// extracted by mini-css-extract-plugin
export var buttons = "_32-0";
export var buttonsActive = "_32-h";
export var cancelConfirm = "_32-1";
export var closeButton = "_32-2";
export var column = "_32-3";
export var container = "_32-4";
export var detailHeader = "_32-6";
export var detailTitle = "_32-7";
export var detailsContent = "_32-5";
export var header = "_32-8";
export var headerWithClose = "_32-9";
export var icon = "_32-a";
export var infoIcon = "_32-c";
export var informationContainer = "_32-b";
export var sideDrawer = "_32-d";
export var sideDrawerOpen = "_32-e";
export var stickyFooter = "_32-f";
export var typeOption = "_32-g";